import './expert-view-modal.scss';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox, Modal } from 'antd';
import CustomButton from 'src/components/shared/custom-button/custom-button';
import { ProtectionMenuNameOptions } from '../../../utils/enums';
import { EXPERT_VIEW_MODAL_FIREWALL, EXPERT_VIEW_MODAL_LIBRARY } from '../../../utils/constants';
import WarningIcon from '@svg/warning.svg?react';

interface ExpertViewModalProps {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    component: ProtectionMenuNameOptions.FIREWALL_RULES | ProtectionMenuNameOptions.Library
}

export const ExpertViewModal: React.FC<ExpertViewModalProps> = observer(({ visible, setVisible, component }) => {

    const [doNotShow, setDoNotShow] = useState(false);

    const close = () => {
        setVisible(false);
        if (doNotShow) {
            const key = component === ProtectionMenuNameOptions.FIREWALL_RULES ? EXPERT_VIEW_MODAL_FIREWALL : EXPERT_VIEW_MODAL_LIBRARY;
            localStorage.setItem(key, 'true');
        }
    };

    const messageBody = `${component === ProtectionMenuNameOptions.FIREWALL_RULES ? 'Firewall' : 'Library'} rules offer advanced protection features and is recommended for ` +
        `users with cybersecurity expertise. Making changes without proper knowledge could compromise your network's functionality.`;

    return <Modal open={visible} className="expert-view-modal-wrapper" width={562} closable={false} footer={null}
        centered>
        <div className="expert-view-modal">
            <div className="expert-view-modal-header">
                <WarningIcon />Advanced settings
            </div>
            <div className="expert-view-modal-body">
                {messageBody}
            </div>
            <div className="expert-view-modal-btns">
                <div className="do-not-show-again"><Checkbox checked={doNotShow}
                    onChange={(e) => setDoNotShow(e.target.checked)}>Do not show
                    again</Checkbox></div>
                <CustomButton className="primary-btn btn-cancel" label="Continue" onClick={close} />
            </div>
        </div>
    </Modal>;
});

